export var SpriteLibrary = [
    {filename: "ship_1.png", name: "Ship_1", index: 0, scale: 0.8},
    {filename: "ship_2.png", name: "Ship_1", index: 1, scale: 0.8},
    {filename: "ship_3.png", name: "Ship_1", index: 2, scale: 0.8},
    {filename: "Schaufel.png", name: "Werkzeug", index: 0, scale: 1.0},
    {filename: "minesweeper/minesweeper.png", name: "Minesweeper", tilesX: 20, tilesY: 1, spacingX: 1, scale: 1.0, index: 0},
    {filename: "minesweeper/minesweeper-numbers.png", name: "Minesweeper", tilesX: 10, tilesY: 1, scale: 1.0, index: 22},

    // Sleepy Blocks
    {filename: "Sleepy_Blocks/sleepy_blocks.png", name: "Sleepy_Blocks", tilesX: 8, tilesY: 1, spacingX: 2, spacingY: 2, scale: 1.0, index: 0, extrudeMarginWidth: 1},

    { filename: "flappy_bird/bird1.png", name: "Bird", index: 0, indexName: "Bird" },
    { filename: "flappy_bird/bird2.png", name: "Bird", index: 1, indexName: "Bird" },
    { filename: "flappy_bird/bird3.png", name: "Bird", index: 2, indexName: "Bird" },
    { filename: "flappy_bird/Baeume.png", name: "Bird", index: 3, indexName: "Bird" },
    { filename: "flappy_bird/houses.png", name: "Bird", index: 4, indexName: "Bird" },
    { filename: "flappy_bird/Leiste.png", name: "Bird", index: 5, indexName: "Bird" },
    { filename: "flappy_bird/Saeule.png", name: "Bird", index: 6, indexName: "Bird" },
    { filename: "flappy_bird/Wolken.png", name: "Bird", index: 7, indexName: "Bird" },

    { filename: "Raumschiff_Adrian/NeuesRaumschiff/raumschiff_0004_geradeaus.png", name: "Space_Shooter_1", index: 0 },
    { filename: "Raumschiff_Adrian/NeuesRaumschiff/raumschiff_0001_runter1.png", name: "Space_Shooter_1", index: 1 },
    { filename: "Raumschiff_Adrian/NeuesRaumschiff/raumschiff_0000_runter2.png", name: "Space_Shooter_1", index: 2 },
    { filename: "Raumschiff_Adrian/NeuesRaumschiff/raumschiff_0003_hoch1.png", name: "Space_Shooter_1", index: 3 },
    { filename: "Raumschiff_Adrian/NeuesRaumschiff/raumschiff_0002_hoch2.png", name: "Space_Shooter_1", index: 4 },

    { filename: "Raumschiff_Adrian/NeuerSchuss.png", name: "Space_Shooter_1", index: 5 },
    { filename: "Raumschiff_Adrian/Schussanimation/schuss_0000.png", name: "Space_Shooter_1", index: 6 },
    { filename: "Raumschiff_Adrian/Schussanimation/schuss_0001.png", name: "Space_Shooter_1", index: 7 },
    { filename: "Raumschiff_Adrian/Schussanimation/schuss_0002.png", name: "Space_Shooter_1", index: 8 },
    { filename: "Raumschiff_Adrian/Schussanimation/schuss_0003.png", name: "Space_Shooter_1", index: 9 },

    { filename: "Raumschiff_Adrian/Asteroid.png", name: "Space_Shooter_1", index: 10 },
    { filename: "Raumschiff_Adrian/Gegner.png", name: "Space_Shooter_1", index: 11 },

    { filename: "Raumschiff_Adrian/Explosion/explosion_0000_..png", name: "Space_Shooter_1", index: 12 },
    { filename: "Raumschiff_Adrian/Explosion/explosion_0001_..png", name: "Space_Shooter_1", index: 13 },
    { filename: "Raumschiff_Adrian/Explosion/explosion_0002_..png", name: "Space_Shooter_1", index: 14 },
    { filename: "Raumschiff_Adrian/Explosion/explosion_0003_..png", name: "Space_Shooter_1", index: 15 },
    { filename: "Raumschiff_Adrian/Explosion/explosion_0004_..png", name: "Space_Shooter_1", index: 16 },
    { filename: "Raumschiff_Adrian/Explosion/explosion_0005_..png", name: "Space_Shooter_1", index: 17 },
    { filename: "Raumschiff_Adrian/Explosion/explosion_0006_..png", name: "Space_Shooter_1", index: 18 },
    { filename: "Raumschiff_Adrian/Explosion/explosion_0007_..png", name: "Space_Shooter_1", index: 19 },
    { filename: "Raumschiff_Adrian/Explosion/explosion_0008_..png", name: "Space_Shooter_1", index: 20 },
    { filename: "Raumschiff_Adrian/Explosion/explosion_0009_..png", name: "Space_Shooter_1", index: 21 },
    { filename: "Raumschiff_Adrian/Explosion/explosion_0010_..png", name: "Space_Shooter_1", index: 22 },
    { filename: "Raumschiff_Adrian/Explosion/explosion_0011_..png", name: "Space_Shooter_1", index: 23 },

    // Spaceshooter 2
    { filename: "classics/spaceship_1.png", name: "Space_Shooter_2", index: 0 },
    { filename: "classics/spaceship_2.png", name: "Space_Shooter_2", index: 1 },
    { filename: "classics/spaceship_3.png", name: "Space_Shooter_2", index: 2 },
    { filename: "classics/spaceship_4.png", name: "Space_Shooter_2", index: 3 },
    { filename: "classics/spaceship_5.png", name: "Space_Shooter_2", index: 4 },
    { filename: "classics/spaceship_6.png", name: "Space_Shooter_2", index: 5 },
    { filename: "classics/spaceship_7.png", name: "Space_Shooter_2", index: 6 },
    { filename: "classics/spaceship_8.png", name: "Space_Shooter_2", index: 7 },
    { filename: "classics/spaceship_9.png", name: "Space_Shooter_2", index: 8 },
    { filename: "classics/missile_1.png", name: "Space_Shooter_2", index: 9 },
    { filename: "classics/missile_2.png", name: "Space_Shooter_2", index: 10 },
    { filename: "classics/missile_3.png", name: "Space_Shooter_2", index: 11 },
    { filename: "classics/missile_4.png", name: "Space_Shooter_2", index: 12 },
    { filename: "classics/missile_5.png", name: "Space_Shooter_2", index: 13 },
    { filename: "classics/missile_6.png", name: "Space_Shooter_2", index: 14 },
    { filename: "classics/missile_7.png", name: "Space_Shooter_2", index: 15 },
    { filename: "classics/missile_8.png", name: "Space_Shooter_2", index: 16 },
    { filename: "classics/missile_9.png", name: "Space_Shooter_2", index: 17 },
    { filename: "classics/missile_10.png", name: "Space_Shooter_2", index: 18 },
    { filename: "classics/missile_11.png", name: "Space_Shooter_2", index: 19 },
    { filename: "classics/missile_12.png", name: "Space_Shooter_2", index: 20 },
    { filename: "classics/satellite_1.png", name: "Space_Shooter_2", index: 21 },
    { filename: "classics/satellite_2.png", name: "Space_Shooter_2", index: 22 },
    
    // Particles
    { filename: "particles/Flare_1.png", name: "Particles", index: 0 },
    { filename: "particles/orb.png", name: "Particles", index: 1 },
    { filename: "particles/white.png", name: "Particles", index: 2 },
    { filename: "particles/ring.png", name: "Particles", index: 3 },
    { filename: "particles/soft5.png", name: "Particles", index: 4 },
    { filename: "particles/soft9.png", name: "Particles", index: 5 },
    { filename: "particles/smoke0.png", name: "Particles", index: 6 },
    { filename: "particles/soft1.png", name: "Particles", index: 7 },
    { filename: "particles/soft7.png", name: "Particles", index: 8 },
    { filename: "particles/soft2.png", name: "Particles", index: 9 },
    { filename: "particles/smoke-puff.png", name: "Particles", index: 10 },
    { filename: "particles/white-smoke.png", name: "Particles", index: 11 },

    // Soko
    {filename: "classics/sokoban_man_horizontal.png", name: "Soko", tilesX: 3, tilesY: 1, spacingX: 2, spacingY: 0, scale: 1.0, index: 0, extrudeMarginWidth: 1},
    {filename: "classics/sokoban_man_vertical.png", name: "Soko", tilesX: 6, tilesY: 1, spacingX: 2, spacingY: 0, scale: 1.0, index: 3, extrudeMarginWidth: 1},
    { filename: "classics/sokoban_box_1.png", name: "Soko", index: 9, extrudeMarginWidth: 1 },
    { filename: "classics/sokoban_box_2.png", name: "Soko", index: 10, extrudeMarginWidth: 1 },
    { filename: "classics/sokoban_empty.png", name: "Soko", index: 11, extrudeMarginWidth: 1 },
    { filename: "classics/sokoban_wall.png", name: "Soko", index: 12, extrudeMarginWidth: 1 },
    { filename: "classics/sokoban_target.png", name: "Soko", index: 13, extrudeMarginWidth: 1 },

    // P-Man
    {filename: "classics/pacman_characters.png", name: "PMan", tilesX: 22, tilesY: 1, spacingX: 2, spacingY: 0, scale: 1.0, index: 0},
    {filename: "classics/pacman_maze.png", name: "PMan", tilesX: 15, tilesY: 1, spacingX: 2, spacingY: 0, scale: 1.0, index: 22},

    // Breakin
    { filename: "classics/bo_bat_long.png", name: "Breakin", index: 0 },
    { filename: "classics/bo_bat_short.png", name: "Breakin", index: 1 },
    { filename: "classics/bo_ball_blue.png", name: "Breakin", index: 2 },
    { filename: "classics/bo_ball_gray.png", name: "Breakin", index: 3 },
    { filename: "classics/bo_rechteck.png", name: "Breakin", index: 4 },
    { filename: "classics/bo_rechteck_active.png", name: "Breakin", index: 5 },
    { filename: "classics/bo_quadrat.png", name: "Breakin", index: 6 },
    { filename: "classics/bo_quadrat_active.png", name: "Breakin", index: 7 },
    { filename: "classics/bo_fuenfeck.png", name: "Breakin", index: 8 },
    { filename: "classics/bo_fuenfeck_active.png", name: "Breakin", index: 9 },
    { filename: "classics/bo_raute.png", name: "Breakin", index: 10 },
    { filename: "classics/bo_raute_active.png", name: "Breakin", index: 11 },
    { filename: "classics/bo_star1.png", name: "Breakin", index: 12 },
    { filename: "classics/bo_star2.png", name: "Breakin", index: 13 },

    // Chess
    // Source: https://commons.wikimedia.org/wiki/Category:SVG_chess_pieces
    { filename: "classics/Chess.png", name: "Boardgames", tilesX: 6, tilesY: 2, spacingX: 2, spacingY: 2, scale: 1.0, index: 0},
    { filename: "classics/Spielstein.png", name: "Boardgames", index: 12 },
    { filename: "classics/wuerfel_1.png", name: "Boardgames", index: 13 },
    { filename: "classics/wuerfel_2.png", name: "Boardgames", index: 14 },
    { filename: "classics/wuerfel_3.png", name: "Boardgames", index: 15 },
    { filename: "classics/wuerfel_4.png", name: "Boardgames", index: 16 },
    { filename: "classics/wuerfel_5.png", name: "Boardgames", index: 17 },
    { filename: "classics/wuerfel_6.png", name: "Boardgames", index: 18 },

    // Platformer
    {filename: "plattformer/Tiles_and_enemies_64x64.png", name: "Plattforms", tilesX: 22, tilesY: 16, spacingX: 2, spacingY: 2, scale: 1.0, index: 0, extrudeMarginWidth: 1},

    // Tower defense
    {filename: "tower-defense/tower-defense.png", name: "TowerDefense", tilesX: 18, tilesY: 10, spacingX: 2, spacingY: 2, scale: 1.0, index: 0, extrudeMarginWidth: 1},

    // Platformer character
    {filename: "plattformer/male.png", name: "Characters_1", tilesX: 6, tilesY: 2, spacingX: 0, spacingY: 0, scale: 1.0, index: 0},
    // {filename: "plattformer/female.png", name: "Characters", tilesX: 6, tilesY: 2, spacingX: 0, spacingY: 0, scale: 1.0, index: 12},

    { filename: "plattformer/background_grass.png", name: "Background", index: 0, scale: 0.2 },
    { filename: "plattformer/background_mountains.png", name: "Background", index: 1, scale: 0.2 },
    { filename: "plattformer/background_sky.png", name: "Background", index: 2, scale: 0.2 },
    { filename: "plattformer/cloud1.png", name: "Background", index: 3, scale: 0.5 },
    { filename: "plattformer/cloud2.png", name: "Background", index: 4, scale: 0.5 },
    { filename: "plattformer/cloud3.png", name: "Background", index: 5, scale: 0.5 },
    { filename: "plattformer/cloud4.png", name: "Background", index: 6, scale: 0.5 },
    { filename: "plattformer/grass1.png", name: "Background", index: 7 },
    { filename: "plattformer/grass2.png", name: "Background", index: 8 },
    { filename: "plattformer/grass3.png", name: "Background", index: 9 },
    { filename: "plattformer/tree1.png", name: "Background", index: 10, scale: 0.5 },
    { filename: "plattformer/tree2.png", name: "Background", index: 11, scale: 0.5 },
    { filename: "plattformer/tree3.png", name: "Background", index: 12, scale: 0.5 },

    //Frogger
    {filename: "frogger/Frogger_1.png", name: "Frogger", tilesX: 3, tilesY: 1, spacingX: 2, spacingY: 0, scale: 1.0, index: 0, extrudeMarginWidth: 1},
    {filename: "frogger/Frogger_car.png", name: "Frogger", tilesX: 2, tilesY: 1, spacingX: 2, spacingY: 0, scale: 1.0, index: 3, extrudeMarginWidth: 1},

    // 3d
    {filename: "3d/minecraft_grass.png", name: "robot", tilesX: 1, tilesY: 1, index: 0},
    {filename: "3d/tiled_grass.png", name: "robot", tilesX: 1, tilesY: 1, index: 2},
    {filename: "3d/grass_side.png", name: "robot", tilesX: 1, tilesY: 1, index: 3},
    {filename: "3d/brick3d_red.png", name: "robot", tilesX: 1, tilesY: 1, index: 4},
    {filename: "3d/brick3d_yellow.png", name: "robot", tilesX: 1, tilesY: 1, index: 5},
    {filename: "3d/brick3d_green.png", name: "robot", tilesX: 1, tilesY: 1, index: 6},
    {filename: "3d/brick3d_blue.png", name: "robot", tilesX: 1, tilesY: 1, index: 7},
    {filename: "3d/rock.png", name: "robot", tilesX: 1, tilesY: 1, index: 8},
    {filename: "3d/bedrock.png", name: "robot", tilesX: 1, tilesY: 1, index: 9},
    {filename: "3d/earth.png", name: "robot", tilesX: 1, tilesY: 1, index: 10},
    {filename: "3d/north.png", name: "robot", tilesX: 1, tilesY: 1, index: 11},

    {filename: "3d/axis_x.png", name: "standard_textures", tilesX: 1, tilesY: 1, index: 0},
    {filename: "3d/axis_y.png", name: "standard_textures", tilesX: 1, tilesY: 1, index: 1},
    {filename: "3d/axis_z.png", name: "standard_textures", tilesX: 1, tilesY: 1, index: 2},


    {filename: "pixelmon/creature1.png", name: "pixelmon", index: 0},
    {filename: "pixelmon/creature2.png", name: "pixelmon", index: 1},
    {filename: "pixelmon/creature3.png", name: "pixelmon", index: 2},
    {filename: "pixelmon/flowersblue.png", name: "pixelmon", index: 3},
    {filename: "pixelmon/flowersred.png", name: "pixelmon", index: 4},
    {filename: "pixelmon/flowerswhite.png", name: "pixelmon", index: 5},
    {filename: "pixelmon/tree.png", name: "pixelmon", index: 6},
    {filename: "pixelmon/grass.png", name: "pixelmon", index: 7},
    {filename: "pixelmon/highgrass.png", name: "pixelmon", index: 8},
    {filename: "pixelmon/highgrassoverlay.png", name: "pixelmon", index: 9},
    {filename: "pixelmon/itembucket.png", name: "pixelmon", index: 10},
    {filename: "pixelmon/plattform.png", name: "pixelmon", index: 11},
    {filename: "pixelmon/player1back.png", name: "pixelmon", index: 12},
    {filename: "pixelmon/player1backwalk1.png", name: "pixelmon", index: 13},
    {filename: "pixelmon/player1backwalk2.png", name: "pixelmon", index: 14},
    {filename: "pixelmon/player1front.png", name: "pixelmon", index: 15},
    {filename: "pixelmon/player1frontwalk1.png", name: "pixelmon", index: 16},
    {filename: "pixelmon/player1frontwalk2.png", name: "pixelmon", index: 17},
    {filename: "pixelmon/player1side.png", name: "pixelmon", index: 18},
    {filename: "pixelmon/player1sidewalk1.png", name: "pixelmon", index: 19},
    {filename: "pixelmon/player1sidewalk2.png", name: "pixelmon", index: 20},
    {filename: "pixelmon/wall1.png", name: "pixelmon", index: 21},
    {filename: "pixelmon/wall2.png", name: "pixelmon", index: 22},
    {filename: "pixelmon/wall3.png", name: "pixelmon", index: 23},
    {filename: "pixelmon/wall4.png", name: "pixelmon", index: 24},
    {filename: "pixelmon/wallstairs1.png", name: "pixelmon", index: 25},
    {filename: "pixelmon/wallstairs2.png", name: "pixelmon", index: 26},
    {filename: "pixelmon/wallstairs3.png", name: "pixelmon", index: 27},
    {filename: "pixelmon/wallstairs4.png", name: "pixelmon", index: 28},
    {filename: "pixelmon/water1.png", name: "pixelmon", index: 29},
    {filename: "pixelmon/water2.png", name: "pixelmon", index: 30},
    {filename: "pixelmon/water3.png", name: "pixelmon", index: 31},
    {filename: "pixelmon/water4.png", name: "pixelmon", index: 32},
    {filename: "pixelmon/way1.png", name: "pixelmon", index: 33},
    {filename: "pixelmon/way2.png", name: "pixelmon", index: 34},
    {filename: "pixelmon/way3.png", name: "pixelmon", index: 35},
    {filename: "pixelmon/way4.png", name: "pixelmon", index: 36},
    {filename: "pixelmon/way5.png", name: "pixelmon", index: 37},
    {filename: "pixelmon/way6.png", name: "pixelmon", index: 38},
    {filename: "pixelmon/way7.png", name: "pixelmon", index: 39},
    {filename: "pixelmon/way8.png", name: "pixelmon", index: 40},
    {filename: "pixelmon/whitefence1.png", name: "pixelmon", index: 41},
    {filename: "pixelmon/whitefence2.png", name: "pixelmon", index: 42},
    {filename: "pixelmon/woodfence1.png", name: "pixelmon", index: 43},
    {filename: "pixelmon/woodfence2.png", name: "pixelmon", index: 44},
    {filename: "little_figure/Animation_Run/Run0.png", name: "Sneaker", index: 0},
    {filename: "little_figure/Animation_Run/Run1.png", name: "Sneaker", index: 1},
    {filename: "little_figure/Animation_Run/Run2.png", name: "Sneaker", index: 2},
    {filename: "little_figure/Animation_Sneak/Sneak0.png", name: "Sneaker", index: 3},
    {filename: "little_figure/Animation_Sneak/Sneak1.png", name: "Sneaker", index: 4},
    {filename: "little_figure/Animation_Sneak/Sneak2.png", name: "Sneaker", index: 5},

    // Kara
    {filename: "javakara/bugeast_r.gif", name: "Kara", index: 0},
    {filename: "javakara/object_leaf.gif", name: "Kara", index: 1},
    {filename: "javakara/object_mushroom.gif", name: "Kara", index: 2},
    {filename: "javakara/object_tree.gif", name: "Kara", index: 3},

    // Java Hamster
    {filename: "javahamster/hamster_bottom.png", name: "Hamster", index: 0},
    {filename: "javahamster/grain.png", name: "Hamster", index: 1},
    {filename: "javahamster/wall.png", name: "Hamster", index: 2}
]

function expandDigits(n, digits){
    let s = "" + n;
    while(s.length < digits) s = "0" + s;
    return s;
}

let spriteLibInit = () => {
    for(let i = 0; i < 56; i++){
        SpriteLibrary.push({
            filename: "explosion-images/explosion" + expandDigits(i, 4) + ".png",
            name: "Explosion_1",
            index: i
        })
    }
    for(let i = 1; i <= 10; i++){
        SpriteLibrary.push({
            filename: "boulders/image_part_" + expandDigits(i, 3) + ".png",
            name: "Boulders",
            index: i - 1
        })
    }
}

spriteLibInit();

if(typeof module != "undefined"){
    module.exports = SpriteLibrary;
}